/**
 * Reads the campaign tags off a landing page's URL so every landing-page event can be split by
 * variant/channel in BigQuery. `campaign` prefers our own `c` tag (set per variant on the OneLink /
 * ad URL) and falls back to `utm_campaign`.
 */
export interface LpCampaign {
  lp_variant: string;
  campaign?: string;
  /** Ad-network id, forwarded verbatim from the URL. Recorded here and sent to OneLink unchanged, so
   *  the web event and the install carry the same raw channel value. */
  pid?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  gclid?: string;
  fbclid?: string;
}

export function readLpCampaign(lpVariant: string, search?: string): LpCampaign {
  const query = search ?? (typeof window !== "undefined" ? window.location.search : "");
  const params = new URLSearchParams(query);
  const out: LpCampaign = { lp_variant: lpVariant };

  const assign = (key: keyof LpCampaign, value: string | null): void => {
    if (value) out[key] = value;
  };

  assign("pid", params.get("pid"));
  assign("utm_source", params.get("utm_source"));
  assign("utm_medium", params.get("utm_medium"));
  assign("utm_campaign", params.get("utm_campaign"));
  assign("utm_content", params.get("utm_content"));
  assign("utm_term", params.get("utm_term"));
  assign("gclid", params.get("gclid"));
  assign("fbclid", params.get("fbclid"));
  // `||`, not `??`: an ad-platform macro can expand `c` to an empty string, which must fall through
  // to utm_campaign rather than suppress it.
  assign("campaign", params.get("c") || out.utm_campaign || null);

  return out;
}
